module.exports = __webpack_public_path__ + "img/alfie-m12.6ad7bca1.jpeg";